export enum ModalActionButton {
  Cancel = 'common_info_no',
  Confirm = 'common_info_yes'
}
